export interface IState {}

export interface IProps {
}

export enum UpperCase{
    none=0,
    smallcaps=1,
    allcaps=2
}